import { CookieOptions } from 'ngx-cookie';

export interface UserInfo {
  familyName: string;
  givenName: string;
  userName: string;
  memberOf: string[];
}

export const cookieOptions: CookieOptions = {
  path: '/',
  domain:
    window.location.hostname === 'localhost'
      ? undefined
      : window.location.hostname,
  sameSite: 'strict',
  secure: window.location.protocol === 'https:',
  httpOnly: false,
};

export function getCookieOptions(): CookieOptions {
  return {
    ...cookieOptions,
    expires: new Date(Date.now() + 5 * (3600 * 1000)),
  };
}
